<script>
export default {
  name: 'AboutComponent',
  data: function () {
    return {
    }
  }
}
</script>
<template>
  <section  class="white">

    <!-- START PARALLAX HEADER -->
    <v-parallax src="/static/img/slides/3.jpg" height="300">
        <v-layout column>
            <!-- <header>
              <h1>Rad Repair, Machine Shop Service and Earth Moving in Labrador West</h1>
              <h5>History of who we are and what we do</h5>
              <div class="quote">Labrador West #1 Industrial Radiator Repair Shop</div>
            </header> -->
        </v-layout>
    </v-parallax>
    <!-- END PARALLAX HEADER -->

    <v-container grid-list-lg id="services" class="maxed">
      <v-layout row wrap>
        <v-flex xs12>
          <header>
            <h1>Radiator Repair and Machine Shop in Western Labrador</h1>
          </header>
        </v-flex>

        <v-flex xs12 class="service-list">
          <div class="service">
            <v-icon large class="main">wrap_text</v-icon>
            <h3>Automotive and Industrial Radiators</h3>
            <ul>
              <li><strong>Testing, repairing &amp; recoring</strong> </li>
              <li><v-icon small>check_circle</v-icon>Cut, groove, repair rubber ends of &amp; rubber line pipe up to 24"</li>
              <li><v-icon small>check_circle</v-icon>Pipe products including elbows, couplings &amp; flanges</li>
              <li><v-icon small>check_circle</v-icon>Metal fabrication and re-fabrication</li>
              <li><v-icon small>check_circle</v-icon>Rebuild most industrial components and machines</li>
            </ul>

          </div>
        </v-flex>

      </v-layout>
    </v-container>
  </section>
</template>



// WEBPACK FOOTER //
// src/components/About.vue